import React, { useContext } from "react";
import { PropertyContext } from "../../../contexts/PropertyContext";

const ColorProperties = ({ selectedColor, handleChange, searchTerm }) => {
  const {
    renderLabelMarginProperties,
    renderLabelPaddingProperties,
    renderLabelBorderProperties,
    renderLabelPositionProperties,
    renderLabelBackgroundProperties,
    renderLabelGradientProperties,

    renderMarginProperties,
    renderPaddingProperties,
    renderBorderProperties,
    renderPositionProperties,
    renderHoveredMarginProperties,
    renderFocusedMarginProperties,
    renderActivatedMarginProperties,
    renderHoveredPaddingProperties,
    renderFocusedPaddingProperties,
    renderActivatedPaddingProperties,
    renderHoveredBorderProperties,
    renderFocusedBorderProperties,
    renderActivatedBorderProperties,
    renderHoveredPositionProperties,
    renderFocusedPositionProperties,
    renderActivatedPositionProperties,
  } = useContext(PropertyContext);

  const renderInput = (label, name, type = "text", additionalProps = {}) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <input
          type={type}
          name={name}
          value={selectedColor ? selectedColor[name] : ""}
          onChange={handleChange}
          style={styles.input}
          {...additionalProps}
        />
      </div>
    );
  };
  const renderSelect = (label, name, options) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <select
          name={name}
          value={selectedColor ? selectedColor[name] : ""}
          onChange={handleChange}
          style={styles.select}
        >
          <option value="">Select</option>
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  };
  const renderMutableInput = (label, name, array) => {
    if (searchTerm && !label.toLowerCase().includes(searchTerm.toLowerCase())) {
      return null;
    }
    return (
      <div key={name} style={styles.inputGroup}>
        <label style={styles.label}>{label}: </label>
        <div style={styles.widthHeightInputGroup}>
          <select
            name={name}
            value={selectedColor ? selectedColor[name] : ""}
            onChange={handleChange}
            style={styles.select}
          >
            {array.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
          <input
            type="text"
            name={name}
            // placeholder="e.g., 100px or 50%"
            value={selectedColor ? selectedColor[name] : ""}
            onChange={handleChange}
            style={styles.input}
          />
        </div>
      </div>
    );
  };

  return (
    <div style={styles.container}>
      <h4 style={styles.heading}>General Properties</h4>
      {renderInput("Label", "label")}
      {renderInput("Value", "value", "color")}
      <h4 key="text-input-heading" style={styles.heading}>
        Text Input Properties
      </h4>
      {renderMutableInput("Width", "width", [
        "auto",
        "fit-content",
        "max-content",
        "min-content",
      ])}
      {renderMutableInput("Height", "height", [
        "auto",
        "fit-content",
        "max-content",
        "min-content",
      ])}
      {renderMarginProperties(renderMutableInput)}
      {renderPaddingProperties(renderMutableInput)}
      {renderBorderProperties(renderMutableInput, renderInput, renderSelect)}
      {renderPositionProperties(renderMutableInput, renderInput, renderSelect)}
      {renderInput("Opacity", "opacity", "number", {
        min: 0,
        max: 1,
        step: 0.1,
      })}
      {renderSelect("Display", "display", [
        "inline-flex",
        "block",
        "inline-block",
      ])}
      {renderMutableInput("Box Shadow", "boxShadow", [
        "none",
        "2px 4px 10px #000000",
      ])}
      {renderSelect("Cursor Type", "cursor", [
        "default",
        "pointer",
        "text",
        "move",
        "wait",
        "help",
        "not-allowed",
        "crosshair",
        "cell",
        "vertical-text",
        "alias",
        "copy",
        "no-drop",
        "grab",
        "grabbing",
        "e-resize",
        "n-resize",
        "ne-resize",
        "nw-resize",
        "s-resize",
        "se-resize",
        "sw-resize",
        "w-resize",
        "ns-resize",
        "ew-resize",
        "nesw-resize",
        "nwse-resize",
        "zoom-in",
        "zoom-out",
        "all-scroll",
      ])}
      <h4 style={styles.heading}>Color Label Properties</h4>
      {renderLabelMarginProperties(renderMutableInput)}
      {renderLabelPaddingProperties(renderMutableInput)}
      {renderLabelBorderProperties(
        renderMutableInput,
        renderInput,
        renderSelect
      )}
      {renderLabelPositionProperties(
        renderMutableInput,
        renderInput,
        renderSelect
      )}
      {renderInput("Color label", "labelcolor", "color")}
      {renderInput("Background Color label", "labelbackgroundColor", "color")}
      {renderLabelBackgroundProperties(
        renderSelect,
        searchTerm,
        handleChange,
        selectedColor
      )}
      {renderLabelGradientProperties(
        renderSelect,
        searchTerm,
        renderInput,
        selectedColor
      )}
      {renderSelect("Font Family label", "labelfontFamily", [
        "Arial",
        "Helvetica",
        "Times New Roman",
        "Courier New",
        "Verdana",
        "Georgia",
        "Palatino",
        "Garamond",
        "Comic Sans MS",
        "Trebuchet MS",
        "Arial Black",
        "Impact",
        "Tahoma",
        "Lucida Sans Unicode",
        "Lucida Grande",
        "Century Gothic",
        "Frank Ruhl",
        "Segoe UI",
        "Gill Sans",
        "Myriad Pro",
        "Futura",
        "Baskerville",
        "Didot",
        "Optima",
        "Caslon",
        "Cambria",
        "Consolas",
        "Menlo",
        "Andale Mono",
        "Inconsolata",
        "Source Sans Pro",
        "Roboto",
        "Open Sans",
        "Lato",
        "Montserrat",
        "Raleway",
        "Oswald",
        "Poppins",
        "Merriweather",
        "PT Sans",
        "Playfair Display",
        "Nunito",
        "Rubik",
        "Josefin Sans",
        "Quicksand",
        "Droid Sans",
        "Noto Sans",
        "Exo 2",
        "Work Sans",
        "Overpass",
        "Alegreya",
        "Bebas Neue",
        "Hind",
        "Anton",
        "Lora",
        "DM Sans",
        "Barlow",
        "Titillium Web",
        "Suisse Int'l",
        "Noto Serif",
        "Tisa",
        "Muli",
        "Arimo",
        "Karla",
        "Zilla Slab",
        "Space Mono",
        "Libre Baskerville",
        "Fira Sans",
        "Archivo Narrow",
        "Varela Round",
        "Oxygen",
        "Catamaran",
        "Cairo",
        "Dosis",
        "Kreon",
        "Bitter",
        "Candal",
        "Averia Serif Libre",
        "Arapey",
        "Hind Guntur",
        "Saira",
        "Titillium",
        "Dancing Script",
        "Satisfy",
        "Raleway Dots",
        "Courgette",
        "Lobster",
        "Pacifico",
        "Shadows Into Light",
        "Sacramento",
        "Rock Salt",
        "Yellowtail",
      ])}
      {renderMutableInput("Font Size label", "labelfontSize", [
        "16px",
        "2em",
        "1rem",
        "75%",
        "1vw",
      ])}
      {renderSelect("Font Weight label", "labelfontWeight", [
        "normal",
        "bold",
        "100",
        "200",
        "300",
        "400",
        "500",
        "600",
        "700",
        "800",
        "900",
      ])}
      {renderSelect("Font Style label", "labelfontStyle", [
        "normal",
        "italic",
        "oblique",
      ])}
      {renderSelect("Font Variant label", "labelfontVariant", [
        "normal",
        "small-caps",
      ])}
      {renderInput("Line Height label", "labellineHeight", "text", {
        placeholder: "e.g., 1.5 or 24px",
      })}
      {renderMutableInput("Text Shadow label", "labeltextShadow", [
        "none",
        "2px 2px 5px #000000",
      ])}
      {renderSelect("Text Align label", "labeltextAlign", [
        "left",
        "center",
        "right",
        "justify",
      ])}
      {renderSelect("Vertical Align label", "labelverticalAlign", [
        "baseline",
        "sub",
        "super",
        "top",
        "text-top",
        "middle",
        "bottom",
        "text-bottom",
      ])}
      {renderSelect("Text Decoration label", "labeltextDecoration", [
        "none",
        "underline",
        "overline",
        "line-through",
        "underline overline",
      ])}
      {renderSelect("Text Transform label", "labeltextTransform", [
        "none",
        "capitalize",
        "uppercase",
        "lowercase",
      ])}
      {renderInput("Letter Spacing label", "labelletterSpacing", "text", {
        placeholder: "e.g., 1px or 0.1em",
      })}
      {renderInput("Word Spacing label", "labelwordSpacing", "text", {
        placeholder: "e.g., 2px or 0.5em",
      })}
      {renderInput("Text Indent label", "labeltextIndent", "text", {
        placeholder: "e.g., 20px or 2em",
      })}
      {renderSelect("White Space label", "labelwhiteSpace", [
        "normal",
        "nowrap",
        "pre",
        "pre-line",
        "pre-wrap",
      ])}
      {renderSelect("Text Overflow label", "labeltextOverflow", [
        "clip",
        "ellipsis",
        "fade",
      ])}
      {renderSelect("Direction label", "labeldirection", ["ltr", "rtl"])}
      {renderSelect("Unicode Bidi label", "labelunicodeBidi", [
        "normal",
        "embed",
        "bidi-override",
      ])}
      {renderSelect("Writing Mode label", "labelwritingMode", [
        "horizontal-tb",
        "vertical-rl",
        "vertical-lr",
      ])}
      {renderInput("Opacity label", "labelopacity", "number", {
        min: 0,
        max: 1,
        step: 0.1,
      })}
      {renderSelect("Display label", "labeldisplay", [
        "none",
        "block",
        "inline-flex",
        "inline-block",
      ])}
      {renderSelect("Cursor Type Label", "labelcursor", [
        "default",
        "pointer",
        "text",
        "move",
        "wait",
        "help",
        "not-allowed",
        "crosshair",
        "cell",
        "vertical-text",
        "alias",
        "copy",
        "no-drop",
        "grab",
        "grabbing",
        "e-resize",
        "n-resize",
        "ne-resize",
        "nw-resize",
        "s-resize",
        "se-resize",
        "sw-resize",
        "w-resize",
        "ns-resize",
        "ew-resize",
        "nesw-resize",
        "nwse-resize",
        "zoom-in",
        "zoom-out",
        "all-scroll",
      ])}
      <h4 key="other-heading" style={styles.heading}>
        Other Properties
      </h4>
      ,
      {renderMutableInput("Transform", "transform", [
        "none",
        "translate(100px, 200px)",
        "translateX(100px)",
        "translateY(200px)",
        "scale(1.5, 1.6)",
        "scaleX(1.5)",
        "scaleY(1.6)",
        "rotate(30deg)",
        "skew(30deg, 10deg)",
        "skewX(30deg)",
        "skewY(10deg)",
        "matrix(1, 0.5, -0.5, 1, 100, 200)",
      ])}
      {renderMutableInput("Transition Timing Function", "transition", [
        "none",
        "ease 3s",
        "linear 3s",
        "ease-in 3s",
        "ease-out 3s",
        "ease-in-out 3s",
        "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
      ])}
      {renderSelect("Pseudo Classes", "pseudoClass", [
        "none",
        "hover",
        "focus",
        "active",
      ])}
      {selectedColor && selectedColor.pseudoClass === "hover" && (
        <>
          {/* {renderMutableInput("Width Hover", "hoveredwidth", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vw",
        ])}
        {renderMutableInput("Height Hover", "hoveredheight", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vh",
        ])} */}
          {renderHoveredMarginProperties(renderMutableInput)}
          {renderHoveredPaddingProperties(renderMutableInput)}
          {renderHoveredBorderProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderHoveredPositionProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderMutableInput("Box Shadow Hover", "hoveredboxShadow", [
            "none",
            "2px 4px 10px #000000",
          ])}
          {renderInput("Opacity Hover", "hoveredOpacity", "number", {
            min: 0,
            max: 1,
            step: 0.01,
          })}
          {renderSelect("Display Hover", "hovereddisplay", [
            "none",
            "block",
            "inline",
            "inline-block",
            "inline-flex",
          ])}

          {renderSelect("Cursor Hover", "hoveredcursor", [
            "default",
            "pointer",
            "text",
            "move",
            "wait",
            "help",
            "not-allowed",
            "crosshair",
            "cell",
            "vertical-text",
            "alias",
            "copy",
            "no-drop",
            "grab",
            "grabbing",
            "e-resize",
            "n-resize",
            "ne-resize",
            "nw-resize",
            "s-resize",
            "se-resize",
            "sw-resize",
            "w-resize",
            "ns-resize",
            "ew-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out",
            "all-scroll",
          ])}
          {renderMutableInput("Transform Hover", "hoveredtransform", [
            "none",
            "translate(100px, 200px)",
            "translateX(100px)",
            "translateY(200px)",
            "scale(1.5, 1.6)",
            "scaleX(1.5)",
            "scaleY(1.6)",
            "rotate(30deg)",
            "skew(30deg, 10deg)",
            "skewX(30deg)",
            "skewY(10deg)",
            "matrix(1, 0.5, -0.5, 1, 100, 200)",
          ])}
          {renderMutableInput(
            "Transition Timing Function",
            "hoveredtransition",
            [
              "none",
              "ease 3s",
              "linear 3s",
              "ease-in 3s",
              "ease-out 3s",
              "ease-in-out 3s",
              "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
            ]
          )}
        </>
      )}
      {selectedColor && selectedColor.pseudoClass === "focus" && (
        <>
          {/* {renderMutableInput("Width Focus", "focusedwidth", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vw",
        ])}
        {renderMutableInput("Height Focus", "focusedheight", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vh",
        ])} */}
          {renderFocusedMarginProperties(renderMutableInput)}
          {renderFocusedPaddingProperties(renderMutableInput)}
          {renderFocusedBorderProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderFocusedPositionProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}

          {renderMutableInput("Box Shadow Focus", "focusedboxShadow", [
            "none",
            "2px 4px 10px #000000",
          ])}
          {renderInput("Opacity Focus", "focusedOpacity", "number", {
            min: 0,
            max: 1,
            step: 0.01,
          })}
          {renderSelect("Display Focus", "focuseddisplay", [
            "none",
            "block",
            "inline",
            "inline-block",
            "inline-flex",
          ])}

          {renderSelect("Cursor Focus", "focusedcursor", [
            "default",
            "pointer",
            "text",
            "move",
            "wait",
            "help",
            "not-allowed",
            "crosshair",
            "cell",
            "vertical-text",
            "alias",
            "copy",
            "no-drop",
            "grab",
            "grabbing",
            "e-resize",
            "n-resize",
            "ne-resize",
            "nw-resize",
            "s-resize",
            "se-resize",
            "sw-resize",
            "w-resize",
            "ns-resize",
            "ew-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out",
            "all-scroll",
          ])}
          {renderMutableInput("Transform Focus", "focusedtransform", [
            "none",
            "translate(100px, 200px)",
            "translateX(100px)",
            "translateY(200px)",
            "scale(1.5, 1.6)",
            "scaleX(1.5)",
            "scaleY(1.6)",
            "rotate(30deg)",
            "skew(30deg, 10deg)",
            "skewX(30deg)",
            "skewY(10deg)",
            "matrix(1, 0.5, -0.5, 1, 100, 200)",
          ])}
          {renderMutableInput(
            "Transition Timing Function Focus",
            "focusedtransition",
            [
              "none",
              "ease 3s",
              "linear 3s",
              "ease-in 3s",
              "ease-out 3s",
              "ease-in-out 3s",
              "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
            ]
          )}
        </>
      )}
      {selectedColor && selectedColor.pseudoClass === "active" && (
        <>
          {/* {renderMutableInput("Width Active", "activatedwidth", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vw",
        ])}
        {renderMutableInput("Height Active", "activatedheight", [
          "auto",
          "fit-content",
          "max-content",
          "min-content",
          "100%",
          "100vh",
        ])} */}
          {renderActivatedMarginProperties(renderMutableInput)}
          {renderActivatedPaddingProperties(renderMutableInput)}
          {renderActivatedBorderProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderActivatedPositionProperties(
            renderMutableInput,
            renderInput,
            renderSelect
          )}
          {renderMutableInput("Box Shadow Active", "activatedboxShadow", [
            "none",
            "2px 4px 10px #000000",
          ])}
          {renderInput("Opacity Active", "activatedOpacity", "number", {
            min: 0,
            max: 1,
            step: 0.01,
          })}
          {renderSelect("Display Activate", "activateddisplay", [
            "none",
            "block",
            "inline",
            "inline-block",
            "inline-flex",
          ])}

          {renderSelect("Cursor Active", "activatedcursor", [
            "default",
            "pointer",
            "text",
            "move",
            "wait",
            "help",
            "not-allowed",
            "crosshair",
            "cell",
            "vertical-text",
            "alias",
            "copy",
            "no-drop",
            "grab",
            "grabbing",
            "e-resize",
            "n-resize",
            "ne-resize",
            "nw-resize",
            "s-resize",
            "se-resize",
            "sw-resize",
            "w-resize",
            "ns-resize",
            "ew-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out",
            "all-scroll",
          ])}
          {renderMutableInput("Transform Active", "activatedtransform", [
            "none",
            "translate(100px, 200px)",
            "translateX(100px)",
            "translateY(200px)",
            "scale(1.5, 1.6)",
            "scaleX(1.5)",
            "scaleY(1.6)",
            "rotate(30deg)",
            "skew(30deg, 10deg)",
            "skewX(30deg)",
            "skewY(10deg)",
            "matrix(1, 0.5, -0.5, 1, 100, 200)",
          ])}
          {renderMutableInput(
            "Transition Timing Function Active",
            "activatedtransition",
            [
              "none",
              "ease 3s",
              "linear 3s",
              "ease-in 3s",
              "ease-out 3s",
              "ease-in-out 3s",
              "cubic-bezier(0.25, 0.1, 0.25, 1.0)",
            ]
          )}
        </>
      )}
    </div>
  );
};

const styles = {
  container: {
    padding: "5px",
    borderRadius: "8px",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
  },
  heading: {
    fontSize: "15px",
    margin: "10px 0",
    color: "#333",
    borderBottom: "1px solid #ccc",
    paddingBottom: "5px",
  },
  inputGroup: {
    margin: "10px 0",
  },
  label: {
    display: "block",
    marginBottom: "5px",
    fontWeight: "bold",
  },
  input: {
    width: "100%",
    padding: "3px 5px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  select: {
    width: "100%",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    boxSizing: "border-box",
  },
  checkbox: {
    marginRight: "5px",
  },
  button: {
    marginTop: "5px",
    padding: "8px",
    backgroundColor: "#4CAF50",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
  },
};

export default ColorProperties;
